import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Tecnologiafeatured() {
    const { csrfToken } = useCsrfToken();
    const [tecnologia, setTecnologia] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const transformData = (data) => {
            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Tecnología',
                name: item.title,
                slug: item.slug,
                desc: item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description,
            }));
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings/technology/1/1`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setTecnologia(transformData(data)))
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [API_URL, csrfToken]);
    return (
        <>
            <div className="row justify-content-center">
                {tecnologia.slice(0, 6).map((item, index) => {
                    const stripTags = (html) => {
                        let doc = new DOMParser().parseFromString(html, 'text/html');
                        return doc.body.textContent || "";
                    };
                    return (
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="listing position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                <div className="position-relative">
                                    <div className="listing-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                        <Link to={`/tecnologia-equipamiento/${item.slug}`}>
                                            <img src={item.image} className="img-fluid" alt="" />
                                        </Link>
                                    </div>

                                    <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                        <span className="badge bg-secondary">{item.tag}</span>
                                    </div>
                                </div>

                                <div className="pt-4 flex-grow-1 d-flex flex-column">
                                    <Link to={`/tecnologia-equipamiento/${item.slug}`} className="text-dark title h5">{item.name}</Link>

                                    <p className="text-muted my-2 flex-grow-1">{stripTags(item.desc)}</p>

                                    <Link to={`/tecnologia-equipamiento/${item.slug}`} className="btn btn-success w-100 btn-sm text-light mt-auto hv:bg-secondary">Conocer más <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
